import React, { useEffect, useState } from 'react';
import axiosInstance from '../axiosConfig';

function InventoryDetails({ inventoryId, onClose, loadOpenInventories }) {
    const [inventoryDetails, setInventoryDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [selectedComponentId, setSelectedComponentId] = useState('');
    const [actualQuantity, setActualQuantity] = useState('');

    useEffect(() => {
        axiosInstance.get(`/api/inventory/${inventoryId}/`)
            .then(response => {
                setInventoryDetails(response.data.inventory);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error loading inventory details:', error);
                setLoading(false);
            });
    }, [inventoryId]);

    const handleComponentChange = (e) => {
        setSelectedComponentId(e.target.value);
        setActualQuantity('');
    };

    const handleQuantityChange = (e) => {
        setActualQuantity(e.target.value);
    };

    const handleAddQuantity = () => {
        if (selectedComponentId && actualQuantity) {
            axiosInstance.post(`/api/inventory/${inventoryId}/add_item/`, {
                component_id: selectedComponentId,
                actual_quantity: actualQuantity
            }).then(response => {
                if (response.data.success) {
                    setInventoryDetails(response.data.inventory);
                    setSelectedComponentId('');
                    setActualQuantity('');

                    window.Toastify({
                        text: "Количество успешно добавлено.",
                        duration: 3000,
                        gravity: "top",
                        position: "right",
                        backgroundColor: "linear-gradient(to right, #00b09b, #96c93d)",
                        stopOnFocus: true,
                        className: 'custom-toast',
                    }).showToast();
                }
            }).catch(error => {
                console.error('Error adding inventory item:', error);
                window.Toastify({
                    text: "Ошибка при добавлении количества.",
                    duration: 3000,
                    gravity: "top",
                    position: "right",
                    backgroundColor: "linear-gradient(to right, #dc3545, #f46b6b)",
                    stopOnFocus: true,
                    className: 'custom-toast',
                }).showToast();
            });
        }
    };

    const handleCompleteInventory = () => {
        axiosInstance.post(`/api/inventory/${inventoryId}/complete/`)
            .then(response => {
                window.Toastify({
                    text: "Инвентаризация завершена.",
                    duration: 3000,
                    gravity: "top",
                    position: "right",
                    backgroundColor: "linear-gradient(to right, #00b09b, #96c93d)",
                    stopOnFocus: true,
                    className: 'custom-toast',
                }).showToast();
                
                loadOpenInventories();
                onClose();
            })
            .catch(error => {
                console.error('Error completing inventory:', error);
                window.Toastify({
                    text: "Ошибка при завершении инвентаризации.",
                    duration: 3000,
                    gravity: "top",
                    position: "right",
                    backgroundColor: "linear-gradient(to right, #dc3545, #f46b6b)",
                    stopOnFocus: true,
                    className: 'custom-toast',
                }).showToast();
            });
    };

    return (
        <div className="container mt-4">
            {loading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: '100px' }}>
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : (
                <div>
                    <button onClick={onClose} className="btn btn-secondary mb-3">Закрыть</button>
                    <h4 className="mb-3">Инвентаризация: {inventoryDetails.project_name}</h4>
                    <p><strong>Дата создания:</strong> {inventoryDetails.created_at}</p>
                    <p><strong>Статус:</strong> {inventoryDetails.completed ? 'Завершена' : 'Открыта'}</p>
                    
                    <h5 className="mt-4 mb-3">Компоненты</h5>
                    <div className="mb-3">
                        <label htmlFor="componentSelect" className="form-label">Выберите компонент:</label>
                        <select
                            id="componentSelect"
                            value={selectedComponentId}
                            onChange={handleComponentChange}
                            className="form-select"
                        >
                            <option value="">--Выберите компонент--</option>
                            {inventoryDetails.remaining_components.map(component => (
                                <option key={component.component_id} value={component.component_id}>
                                    {component.component_name}
                                </option>
                            ))}
                        </select>

                        {selectedComponentId && (
                            <div className="mt-3">
                                <label htmlFor="quantityInput" className="form-label">Введите количество:</label>
                                <input
                                    type="number"
                                    id="quantityInput"
                                    value={actualQuantity}
                                    onChange={handleQuantityChange}
                                    className="form-control"
                                />
                                <button onClick={handleAddQuantity} className="btn btn-primary mt-2">
                                    Добавить количество
                                </button>
                            </div>
                        )}
                    </div>

                    <h5 className="mt-4 mb-3">Фактические данные</h5>
                    <ul className="list-group">
                        {inventoryDetails.items.map(item => (
                            <li key={item.component_id} className="list-group-item">
                                {item.component_name}: {item.actual_quantity}
                            </li>
                        ))}
                    </ul>

                    {inventoryDetails.remaining_components.length === 0 && (
                        <button onClick={handleCompleteInventory} className="btn btn-success mt-3">
                            Завершить инвентаризацию
                        </button>
                    )}
                </div>
            )}
        </div>
    );
}

export default InventoryDetails;
